import { createTrackers } from '@spp/tracking';
import pulseEngageTracker from './pulse-engage-tracker';
import comScoreTracker from './comScore-tracker';
import linkPulseTracker from './linkPulse-tracker';

const configuredPulseEngageTracker = pulseEngageTracker();
const configuredcomScoreTracker = comScoreTracker();
const configuredLinkPulseTracker = linkPulseTracker();

const clientTrackers = createTrackers({
    trackers: {
        engage: configuredPulseEngageTracker,
        comScore: configuredcomScoreTracker,
        linkPulse: configuredLinkPulseTracker,
    },
    onError: (err, params, trackerId) =>
        // eslint-disable-next-line no-console
        console.log('tracking error ', err, params, trackerId), // Look into logging
});

export default clientTrackers;



/** WEBPACK FOOTER **
 ** ./src/tracking/client-trackers.js
 **/